// Starter code and tutorial provided by Angela Yu
// https://www.appbrewery.co/p/web-development-course-resources/

import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';

ReactDOM.render(
  <App/>,
  document.getElementById('root')
);
